import React from 'react';

import type { MediaGalleryActions, MediaListItem } from '../../types';
import Actions from '../Actions';
import { ItemWrapper } from '../UI';

type FailedMediaProps = {
  media: MediaListItem;
} & Pick<MediaGalleryActions, 'onDelete' | 'onRetry'>;

const FailedMedia: React.FC<FailedMediaProps> = ({ media, onDelete, onRetry }) => (
  <React.Fragment>
    <ItemWrapper>
      <i className="fb-icon--warning text-warning" />
    </ItemWrapper>
    <Actions media={media} onDelete={onDelete} onRetry={onRetry} />
  </React.Fragment>
);

export default FailedMedia;
